var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTickCircleinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M32 0c17.673 0 32 14.327 32 32S49.673 64 32 64 0 49.673 0 32 14.327 0 32 0m0 2C15.431 2 2 15.431 2 32s13.431 30 30 30 30-13.431 30-30S48.569 2 32 2m10.358 17.953 1.689 1.071L29.39 44.133l-9.46-7.372 1.23-1.578L28.88 41.2z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  fill: "currentColor",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h64v64H0z"
})))));
export default SvgTickCircleinline;